import {CommonModule} from '@angular/common';
import {Component, Input, NgModule, OnInit} from '@angular/core';
import {DxContextMenuModule} from 'devextreme-angular';
import {DxListModule} from 'devextreme-angular';
import {FusionAuthService} from 'src/app/shared/services/fusion-auth/fusion-auth.service';
import {User} from 'src/app/shared/models/fusion-auth';
import {ThemeToggleComponent} from "../theme-toggle/theme-toggle.component";
import {DxSwitchModule} from "devextreme-angular";

@Component({
  selector: 'app-user-panel',
  templateUrl: 'user-panel.component.html',
  styleUrls: ['./user-panel.component.scss'],
})
export class UserPanelComponent implements OnInit {
  @Input()
  public menuItems: any;
  public profile?: User;
  @Input()
  public menuMode?: string;

  constructor(private fusionAuth: FusionAuthService) {
  }

  public ngOnInit(): void {
    this.profile = this.fusionAuth.Profile;
  }
}

@NgModule({
  imports: [DxListModule, DxContextMenuModule, CommonModule, DxSwitchModule],
  declarations: [UserPanelComponent],
  exports: [UserPanelComponent],
})
export class UserPanelModule {
}
